/**
 * Cookbook Dropdowns
 */

import initCTADropdown from '../../components/cta-dropdown';

document.addEventListener( 'DOMContentLoaded', () => {
	initCTADropdown();
} );

// Enable HMR
if ( module.hot ) {
	module.hot.accept();
}
